export default {
  subscription: undefined,
};
